import React from 'react'
import { Box, Grid, Typography } from '@material-ui/core'
import { useStyles } from './MemberDetails.style'
import Image from '../Image'
import LinkWithIcon from '../LinkWithIcon'

const PLACEHOLDER_IMAGE = '/assets/desktop/About/02-2%20Board.jpg'

const MemberDetails = (props) => {
  const { heading, description, personCard: members = [], link } = props

  const styles = useStyles()
  return (
    <>
      <Typography variant="h3" className={styles.teamTitle}>
        {heading}
      </Typography>
      <Typography valiant="body1" className={styles.teamParagraph}>
        {description.description}
      </Typography>
      {members && (
        <Grid className={styles.teamMemberContainer}>
          {members.map((member, index) => {
            const imageUrl = member.imageUrl || PLACEHOLDER_IMAGE
            return (
              <a
                className={styles.teamMemberCardLink}
                target="_blank"
                href={member.cvUrl}
                rel="noreferrer"
                key={index}
              >
                <Box className={styles.teamMemberCard}>
                  <Image
                    file={{ url: imageUrl }}
                    className={styles.memberImage}
                    title={member.personName}
                  />
                  <Box className={styles.teamMemberInfo}>
                    <Typography className={styles.teamMemberName}>
                      {member.personName}
                    </Typography>
                    <Typography variant="body2">
                      {member.designation}
                    </Typography>
                  </Box>
                </Box>
              </a>
            )
          })}
        </Grid>
      )}
      {link && (
        <LinkWithIcon
          text={link.title}
          to={link.link}
          isExternal={link.isExternal}
        />
      )}
    </>
  )
}

export default MemberDetails
